module.exports = __webpack_public_path__ + "assets/whatsapp.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/whatsapp.svg
// module id = 763
// module chunks = 0